import { render, staticRenderFns } from "./Particle.vue?vue&type=template&id=8dea56ae&scoped=true&"
import script from "./Particle.vue?vue&type=script&lang=js&"
export * from "./Particle.vue?vue&type=script&lang=js&"
import style0 from "./Particle.vue?vue&type=style&index=0&id=8dea56ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dea56ae",
  null
  
)

export default component.exports